import { IconCopy, IconDotsVertical, IconTrash } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import { useState } from 'react';
import {
    Dropdown, DropdownItem, DropdownMenu, DropdownToggle,
} from 'reactstrap';
import { NSButton } from 'bricks';

type ActivityActionsMenuProps = {
    onDuplicate: () => void;
    onDelete: () => void;
    dataTestIdPrefix: string;
};

const ActivityActionsMenu = ({ onDuplicate, onDelete, dataTestIdPrefix }: ActivityActionsMenuProps) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <Dropdown isOpen={isOpen} toggle={() => setIsOpen(prev => !prev)} direction="down">
            <DropdownToggle tag="button" className="btn p-0 border-0 bg-transparent">
                <NSButton color="secondary" icon={IconDotsVertical} ariaLabel="Activity actions" />
            </DropdownToggle>
            <DropdownMenu end>
                <DropdownItem onClick={onDuplicate} className="text-white" data-testid={`${dataTestIdPrefix}-duplicate`}>
                    <div className="d-flex align-items-center justify-content-between w-100">
                        <span>Duplicate task</span>
                        <NSIcon icon={IconCopy} />
                    </div>
                </DropdownItem>
                <DropdownItem onClick={onDelete} className="text-white" data-testid={`${dataTestIdPrefix}-delete`}>
                    <div className="d-flex align-items-center justify-content-between w-100">
                        <span>Delete task</span>
                        <NSIcon icon={IconTrash} />
                    </div>
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    );
};

export default ActivityActionsMenu;
